import { render, staticRenderFns } from "./EventPayment.vue?vue&type=template&id=5b52ec64&scoped=true&"
import script from "./EventPayment.vue?vue&type=script&lang=js&"
export * from "./EventPayment.vue?vue&type=script&lang=js&"
import style0 from "./EventPayment.vue?vue&type=style&index=0&id=5b52ec64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52ec64",
  null
  
)

export default component.exports